import type React from 'react';

import styles from './styles/labelValueList.module.scss';

export type LabelValue = {
  label?: string;
  value?: string;
};

interface Props {
  items: LabelValue[];
}

const LabelValueList: React.FC<Props> = ({ items }) => {
  return (
    <div className={styles.container}>
      {items.map(item => {
        const key = `${item.label ?? ''}-${item.value ?? ''}`;
        return (
          <div key={key}>
            <span className={styles.label}>{item.label}</span>
            <span className={styles.value}>{item.value}</span>
          </div>
        );
      })}
    </div>
  );
};

export default LabelValueList;
